import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _CustomAttrSerializer;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/opt/build/repo/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _hotKeys, _fullscreenElement, _keyUpHandler, _keyUpHandler_fn, _keyDownHandler, keyDownHandler_fn;

import { MediaContainer } from "./media-container.js";
import { globalThis } from "./utils/server-safe-globals.js";
import { AttributeTokenList } from "./utils/attribute-token-list.js";
import { constToCamel, delay, stringifyRenditionList, stringifyAudioTrackList } from "./utils/utils.js";
import { stringifyTextTrackList, toggleSubsCaps } from "./utils/captions.js";
import { MediaUIEvents, MediaUIAttributes, MediaStateReceiverAttributes, AttributeToStateChangeEventMap, MediaUIProps } from "./constants.js";
import { MediaUIRequestHandlers, MediaUIStates, volumeSupportPromise } from "./controller.js";
import { setBooleanAttr, setNumericAttr, setStringAttr } from "./utils/element-utils.js";
var ButtonPressedKeys = ["ArrowLeft", "ArrowRight", "Enter", " ", "f", "m", "k", "c"];
var DEFAULT_SEEK_OFFSET = 10;
var DEFAULT_TIME = 0;
var Attributes = {
  DEFAULT_SUBTITLES: "defaultsubtitles",
  DEFAULT_STREAM_TYPE: "defaultstreamtype",
  FULLSCREEN_ELEMENT: "fullscreenelement",
  HOTKEYS: "hotkeys",
  KEYS_USED: "keysused",
  LIVE_EDGE_OFFSET: "liveedgeoffset",
  NO_AUTO_SEEK_TO_LIVE: "noautoseektolive",
  NO_HOTKEYS: "nohotkeys"
};

var MediaController = /*#__PURE__*/function (_MediaContainer) {
  _inherits(MediaController, _MediaContainer);

  var _super = _createSuper(MediaController);

  function MediaController() {
    var _this;

    _classCallCheck(this, MediaController);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _keyUpHandler);

    __privateAdd(_assertThisInitialized(_this), _keyDownHandler);

    __privateAdd(_assertThisInitialized(_this), _hotKeys, new AttributeTokenList(_assertThisInitialized(_this), Attributes.HOTKEYS));

    __privateAdd(_assertThisInitialized(_this), _fullscreenElement, void 0);

    if (MediaUIStates.MEDIA_VOLUME_UNAVAILABLE.get(_assertThisInitialized(_this)) === void 0) {
      volumeSupportPromise.then(function () {
        _this.propagateMediaState(MediaUIAttributes.MEDIA_VOLUME_UNAVAILABLE, MediaUIStates.MEDIA_VOLUME_UNAVAILABLE.get(_assertThisInitialized(_this)));
      });
    }

    _this.mediaStateReceivers = [];
    _this.associatedElementSubscriptions = /* @__PURE__ */new Map();

    _this.associateElement(_assertThisInitialized(_this));

    Object.keys(MediaUIRequestHandlers).forEach(function (key) {
      var handlerName = "_handle".concat(constToCamel(key, true));

      _this[handlerName] = function (e) {
        e.stopPropagation();

        if (!_this.media) {
          console.warn("MediaController: No media available.");
          return;
        }

        MediaUIRequestHandlers[key](_this.media, e, _assertThisInitialized(_this));
      };

      _this.addEventListener(MediaUIEvents[key], _this[handlerName]);
    });
    _this._mediaStatePropagators = {};
    Object.keys(MediaUIStates).forEach(function (key) {
      _this._mediaStatePropagators[key] = function (e) {
        _this.propagateMediaState(MediaUIProps[key], MediaUIStates[key].get(_assertThisInitialized(_this), e));
      };
    });

    _this.enableHotkeys();

    return _this;
  }

  _createClass(MediaController, [{
    key: "fullscreenElement",
    get: function get() {
      var _a;

      return (_a = __privateGet(this, _fullscreenElement)) != null ? _a : this;
    },
    set: function set(element) {
      if (this.hasAttribute(Attributes.FULLSCREEN_ELEMENT)) {
        this.removeAttribute(Attributes.FULLSCREEN_ELEMENT);
      }

      __privateSet(this, _fullscreenElement, element);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a;

      if (attrName === Attributes.NO_HOTKEYS) {
        if (newValue !== oldValue && newValue === "") {
          if (this.hasAttribute(Attributes.HOTKEYS)) {
            console.warn("Both `hotkeys` and `nohotkeys` have been set. All hotkeys will be disabled.");
          }

          this.disableHotkeys();
        } else if (newValue !== oldValue && newValue === null) {
          this.enableHotkeys();
        }
      } else if (attrName === Attributes.HOTKEYS) {
        __privateGet(this, _hotKeys).value = newValue;
      } else if (attrName === Attributes.DEFAULT_SUBTITLES && newValue !== oldValue && newValue === "") {
        toggleSubsCaps(this, true);
      } else if (attrName === Attributes.DEFAULT_STREAM_TYPE) {
        this.propagateMediaState(MediaUIProps.MEDIA_STREAM_TYPE);
      } else if (attrName === Attributes.FULLSCREEN_ELEMENT) {
        var el = newValue ? (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(newValue) : void 0;

        __privateSet(this, _fullscreenElement, el);
      }

      _get(_getPrototypeOf(MediaController.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);
    }
  }, {
    key: "mediaSetCallback",
    value: function mediaSetCallback(media) {
      var _this2 = this;

      _get(_getPrototypeOf(MediaController.prototype), "mediaSetCallback", this).call(this, media);

      if (!media.hasAttribute("tabindex")) {
        media.tabIndex = -1;
      }

      Object.keys(MediaUIStates).forEach(function (key) {
        var _MediaUIStates$key = MediaUIStates[key],
            mediaEvents = _MediaUIStates$key.mediaEvents,
            rootEvents = _MediaUIStates$key.rootEvents,
            textTracksEvents = _MediaUIStates$key.textTracksEvents,
            videoRenditionsEvents = _MediaUIStates$key.videoRenditionsEvents,
            audioTracksEvents = _MediaUIStates$key.audioTracksEvents;
        var handler = _this2._mediaStatePropagators[key];
        mediaEvents == null ? void 0 : mediaEvents.forEach(function (eventName) {
          media.addEventListener(eventName, handler);
          handler();
        });
        rootEvents == null ? void 0 : rootEvents.forEach(function (eventName) {
          _this2.getRootNode().addEventListener(eventName, handler);

          handler();
        });
        textTracksEvents == null ? void 0 : textTracksEvents.forEach(function (eventName) {
          var _a;

          (_a = media.textTracks) == null ? void 0 : _a.addEventListener(eventName, handler);
          handler();
        });
        videoRenditionsEvents == null ? void 0 : videoRenditionsEvents.forEach(function (eventName) {
          var _a;

          (_a = media.videoRenditions) == null ? void 0 : _a.addEventListener(eventName, handler);
          handler();
        });
        audioTracksEvents == null ? void 0 : audioTracksEvents.forEach(function (eventName) {
          var _a;

          (_a = media.audioTracks) == null ? void 0 : _a.addEventListener(eventName, handler);
          handler();
        });
      });

      if (!this.hasAttribute("novolumepref")) {
        try {
          var volPref = globalThis.localStorage.getItem("media-chrome-pref-volume");
          if (volPref !== null) media.volume = volPref;
        } catch (e) {
          console.debug("Error getting volume pref", e);
        }
      }
    }
  }, {
    key: "mediaUnsetCallback",
    value: function mediaUnsetCallback(media) {
      var _this3 = this;

      _get(_getPrototypeOf(MediaController.prototype), "mediaUnsetCallback", this).call(this, media);

      Object.keys(MediaUIStates).forEach(function (key) {
        var _MediaUIStates$key2 = MediaUIStates[key],
            mediaEvents = _MediaUIStates$key2.mediaEvents,
            rootEvents = _MediaUIStates$key2.rootEvents,
            textTracksEvents = _MediaUIStates$key2.textTracksEvents,
            videoRenditionsEvents = _MediaUIStates$key2.videoRenditionsEvents,
            audioTracksEvents = _MediaUIStates$key2.audioTracksEvents;
        var handler = _this3._mediaStatePropagators[key];
        mediaEvents == null ? void 0 : mediaEvents.forEach(function (eventName) {
          media.removeEventListener(eventName, handler);
        });
        rootEvents == null ? void 0 : rootEvents.forEach(function (eventName) {
          _this3.getRootNode().removeEventListener(eventName, handler);
        });
        textTracksEvents == null ? void 0 : textTracksEvents.forEach(function (eventName) {
          var _a;

          (_a = media.textTracks) == null ? void 0 : _a.removeEventListener(eventName, handler);
        });
        videoRenditionsEvents == null ? void 0 : videoRenditionsEvents.forEach(function (eventName) {
          var _a;

          (_a = media.videoRenditions) == null ? void 0 : _a.removeEventListener(eventName, handler);
          handler();
        });
        audioTracksEvents == null ? void 0 : audioTracksEvents.forEach(function (eventName) {
          var _a;

          (_a = media.audioTracks) == null ? void 0 : _a.removeEventListener(eventName, handler);
          handler();
        });
      });
      this.propagateMediaState(MediaUIProps.MEDIA_PAUSED, true);
    }
  }, {
    key: "propagateMediaState",
    value: function propagateMediaState(stateName, state) {
      var previousState = getStateValue(this.mediaStateReceivers, stateName);

      _propagateMediaState(this.mediaStateReceivers, stateName, state);

      if (previousState === getStateValue(this.mediaStateReceivers, stateName)) return;
      var attrName = stateName.toLowerCase();
      var evt = new globalThis.CustomEvent(AttributeToStateChangeEventMap[attrName], {
        composed: true,
        bubbles: true,
        detail: state
      });
      this.dispatchEvent(evt);
    }
  }, {
    key: "associateElement",
    value: function associateElement(element) {
      var _this4 = this;

      if (!element) return;
      var associatedElementSubscriptions = this.associatedElementSubscriptions;
      if (associatedElementSubscriptions.has(element)) return;
      var registerMediaStateReceiver = this.registerMediaStateReceiver.bind(this);
      var unregisterMediaStateReceiver = this.unregisterMediaStateReceiver.bind(this);
      var unsubscribe = monitorForMediaStateReceivers(element, registerMediaStateReceiver, unregisterMediaStateReceiver);
      Object.keys(MediaUIEvents).forEach(function (key) {
        element.addEventListener(MediaUIEvents[key], _this4["_handle".concat(constToCamel(key, true))]);
      });
      associatedElementSubscriptions.set(element, unsubscribe);
    }
  }, {
    key: "unassociateElement",
    value: function unassociateElement(element) {
      var _this5 = this;

      if (!element) return;
      var associatedElementSubscriptions = this.associatedElementSubscriptions;
      if (!associatedElementSubscriptions.has(element)) return;
      var unsubscribe = associatedElementSubscriptions.get(element);
      unsubscribe();
      associatedElementSubscriptions.delete(element);
      Object.keys(MediaUIEvents).forEach(function (key) {
        element.removeEventListener(MediaUIEvents[key], _this5["_handle".concat(constToCamel(key, true))]);
      });
    }
  }, {
    key: "registerMediaStateReceiver",
    value: function registerMediaStateReceiver(el) {
      var _this6 = this;

      if (!el) return;
      var els = this.mediaStateReceivers;
      var index = els.indexOf(el);
      if (index > -1) return;
      els.push(el);
      Object.keys(MediaUIStates).forEach(function (stateConstName) {
        var stateDetails = MediaUIStates[stateConstName];

        _propagateMediaState([el], MediaUIProps[stateConstName], stateDetails.get(_this6));
      });
    }
  }, {
    key: "unregisterMediaStateReceiver",
    value: function unregisterMediaStateReceiver(el) {
      var els = this.mediaStateReceivers;
      var index = els.indexOf(el);
      if (index < 0) return;
      els.splice(index, 1);
    }
  }, {
    key: "enableHotkeys",
    value: function enableHotkeys() {
      this.addEventListener("keydown", __privateMethod(this, _keyDownHandler, keyDownHandler_fn));
    }
  }, {
    key: "disableHotkeys",
    value: function disableHotkeys() {
      this.removeEventListener("keydown", __privateMethod(this, _keyDownHandler, keyDownHandler_fn));
      this.removeEventListener("keyup", __privateMethod(this, _keyUpHandler, _keyUpHandler_fn));
    }
  }, {
    key: "hotkeys",
    get: function get() {
      return __privateGet(this, _hotKeys);
    }
  }, {
    key: "keyboardShortcutHandler",
    value: function keyboardShortcutHandler(e) {
      var _a, _b, _c, _d;

      var keysUsed = ((_d = (_c = (_a = e.target.getAttribute(Attributes.KEYS_USED)) == null ? void 0 : _a.split(" ")) != null ? _c : (_b = e.target) == null ? void 0 : _b.keysUsed) != null ? _d : []).map(function (key) {
        return key === "Space" ? " " : key;
      }).filter(Boolean);

      if (keysUsed.includes(e.key)) {
        return;
      }

      var eventName, currentTimeStr, currentTime, detail, evt;
      var seekOffset = DEFAULT_SEEK_OFFSET;
      if (__privateGet(this, _hotKeys).contains("no".concat(e.key.toLowerCase()))) return;
      if (e.key === " " && __privateGet(this, _hotKeys).contains("nospace")) return;

      switch (e.key) {
        case " ":
        case "k":
          eventName = this.getAttribute(MediaUIAttributes.MEDIA_PAUSED) != null ? MediaUIEvents.MEDIA_PLAY_REQUEST : MediaUIEvents.MEDIA_PAUSE_REQUEST;
          this.dispatchEvent(new globalThis.CustomEvent(eventName, {
            composed: true,
            bubbles: true
          }));
          break;

        case "m":
          eventName = this.getAttribute(MediaUIAttributes.MEDIA_VOLUME_LEVEL) === "off" ? MediaUIEvents.MEDIA_UNMUTE_REQUEST : MediaUIEvents.MEDIA_MUTE_REQUEST;
          this.dispatchEvent(new globalThis.CustomEvent(eventName, {
            composed: true,
            bubbles: true
          }));
          break;

        case "f":
          eventName = this.getAttribute(MediaUIAttributes.MEDIA_IS_FULLSCREEN) != null ? MediaUIEvents.MEDIA_EXIT_FULLSCREEN_REQUEST : MediaUIEvents.MEDIA_ENTER_FULLSCREEN_REQUEST;
          this.dispatchEvent(new globalThis.CustomEvent(eventName, {
            composed: true,
            bubbles: true
          }));
          break;

        case "c":
          toggleSubsCaps(this);
          break;

        case "ArrowLeft":
          currentTimeStr = this.getAttribute(MediaUIAttributes.MEDIA_CURRENT_TIME);
          currentTime = currentTimeStr && !Number.isNaN(+currentTimeStr) ? +currentTimeStr : DEFAULT_TIME;
          detail = Math.max(currentTime - seekOffset, 0);
          evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_SEEK_REQUEST, {
            composed: true,
            bubbles: true,
            detail: detail
          });
          this.dispatchEvent(evt);
          break;

        case "ArrowRight":
          currentTimeStr = this.getAttribute(MediaUIAttributes.MEDIA_CURRENT_TIME);
          currentTime = currentTimeStr && !Number.isNaN(+currentTimeStr) ? +currentTimeStr : DEFAULT_TIME;
          detail = Math.max(currentTime + seekOffset, 0);
          evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_SEEK_REQUEST, {
            composed: true,
            bubbles: true,
            detail: detail
          });
          this.dispatchEvent(evt);
          break;

        default:
          break;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _get(_getPrototypeOf(MediaController), "observedAttributes", this).concat(Attributes.NO_HOTKEYS, Attributes.HOTKEYS, Attributes.DEFAULT_STREAM_TYPE, Attributes.DEFAULT_SUBTITLES);
    }
  }]);

  return MediaController;
}(MediaContainer);

_hotKeys = new WeakMap();
_fullscreenElement = new WeakMap();
_keyUpHandler = new WeakSet();

_keyUpHandler_fn = function keyUpHandler_fn(e) {
  var key = e.key;

  if (!ButtonPressedKeys.includes(key)) {
    this.removeEventListener("keyup", __privateMethod(this, _keyUpHandler, _keyUpHandler_fn));
    return;
  }

  this.keyboardShortcutHandler(e);
};

_keyDownHandler = new WeakSet();

keyDownHandler_fn = function keyDownHandler_fn(e) {
  var metaKey = e.metaKey,
      altKey = e.altKey,
      key = e.key;

  if (metaKey || altKey || !ButtonPressedKeys.includes(key)) {
    this.removeEventListener("keyup", __privateMethod(this, _keyUpHandler, _keyUpHandler_fn));
    return;
  }

  if ([" ", "ArrowLeft", "ArrowRight"].includes(key) && !(__privateGet(this, _hotKeys).contains("no".concat(key.toLowerCase())) || key === " " && __privateGet(this, _hotKeys).contains("nospace"))) {
    e.preventDefault();
  }

  this.addEventListener("keyup", __privateMethod(this, _keyUpHandler, _keyUpHandler_fn), {
    once: true
  });
};

var MEDIA_UI_ATTRIBUTE_NAMES = Object.values(MediaUIAttributes);
var MEDIA_UI_PROP_NAMES = Object.values(MediaUIProps);

var getMediaUIAttributesFrom = function getMediaUIAttributesFrom(child) {
  var _a, _b, _c, _d;

  var observedAttributes = child.constructor.observedAttributes;

  if (!observedAttributes && ((_a = child.nodeName) == null ? void 0 : _a.includes("-"))) {
    globalThis.customElements.upgrade(child);
    observedAttributes = child.constructor.observedAttributes;
  }

  var mediaChromeAttributesList = (_d = (_c = (_b = child == null ? void 0 : child.getAttribute) == null ? void 0 : _b.call(child, MediaStateReceiverAttributes.MEDIA_CHROME_ATTRIBUTES)) == null ? void 0 : _c.split) == null ? void 0 : _d.call(_c, /\s+/);
  if (!Array.isArray(observedAttributes || mediaChromeAttributesList)) return [];
  return (observedAttributes || mediaChromeAttributesList).filter(function (attrName) {
    return MEDIA_UI_ATTRIBUTE_NAMES.includes(attrName);
  });
};

var hasMediaUIProps = function hasMediaUIProps(mediaStateReceiverCandidate) {
  var _a, _b;

  if (((_a = mediaStateReceiverCandidate.nodeName) == null ? void 0 : _a.includes("-")) && !!globalThis.customElements.get((_b = mediaStateReceiverCandidate.nodeName) == null ? void 0 : _b.toLowerCase()) && !(mediaStateReceiverCandidate instanceof globalThis.customElements.get(mediaStateReceiverCandidate.nodeName.toLowerCase()))) {
    globalThis.customElements.upgrade(mediaStateReceiverCandidate);
  }

  return MEDIA_UI_PROP_NAMES.some(function (propName) {
    return propName in mediaStateReceiverCandidate;
  });
};

var isMediaStateReceiver = function isMediaStateReceiver(child) {
  return hasMediaUIProps(child) || !!getMediaUIAttributesFrom(child).length;
};

var serializeTuple = function serializeTuple(tuple) {
  var _a;

  return (_a = tuple == null ? void 0 : tuple.join) == null ? void 0 : _a.call(tuple, ":");
};

var CustomAttrSerializer = (_CustomAttrSerializer = {}, _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_SUBTITLES_LIST, stringifyTextTrackList), _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_SUBTITLES_SHOWING, stringifyTextTrackList), _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_SEEKABLE, serializeTuple), _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_BUFFERED, function (tuples) {
  return tuples == null ? void 0 : tuples.map(serializeTuple).join(" ");
}), _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_PREVIEW_COORDS, function (coords) {
  return coords == null ? void 0 : coords.join(" ");
}), _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_RENDITION_LIST, stringifyRenditionList), _defineProperty(_CustomAttrSerializer, MediaUIAttributes.MEDIA_AUDIO_TRACK_LIST, stringifyAudioTrackList), _CustomAttrSerializer);

var setAttr = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(child, attrName, attrValue) {
    var _a, _b, val;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (child.isConnected) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return delay(0);

          case 3:
            if (!(typeof attrValue === "boolean" || attrValue == null)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", setBooleanAttr(child, attrName, attrValue));

          case 5:
            if (!(typeof attrValue === "number")) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", setNumericAttr(child, attrName, attrValue));

          case 7:
            if (!(typeof attrValue === "string")) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", setStringAttr(child, attrName, attrValue));

          case 9:
            if (!(Array.isArray(attrValue) && !attrValue.length)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", child.removeAttribute(attrName));

          case 11:
            val = (_b = (_a = CustomAttrSerializer[attrName]) == null ? void 0 : _a.call(CustomAttrSerializer, attrValue)) != null ? _b : attrValue;
            return _context.abrupt("return", child.setAttribute(attrName, val));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setAttr(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var isMediaSlotElementDescendant = function isMediaSlotElementDescendant(el) {
  var _a;

  return !!((_a = el.closest) == null ? void 0 : _a.call(el, '*[slot="media"]'));
};

var traverseForMediaStateReceivers = function traverseForMediaStateReceivers(rootNode, mediaStateReceiverCallback) {
  if (isMediaSlotElementDescendant(rootNode)) {
    return;
  }

  var traverseForMediaStateReceiversSync = function traverseForMediaStateReceiversSync(rootNode2, mediaStateReceiverCallback2) {
    var _a, _b;

    if (isMediaStateReceiver(rootNode2)) {
      mediaStateReceiverCallback2(rootNode2);
    }

    var _ref2 = rootNode2 != null ? rootNode2 : {},
        _ref2$children = _ref2.children,
        children = _ref2$children === void 0 ? [] : _ref2$children;

    var shadowChildren = (_b = (_a = rootNode2 == null ? void 0 : rootNode2.shadowRoot) == null ? void 0 : _a.children) != null ? _b : [];
    var allChildren = [].concat(_toConsumableArray(children), _toConsumableArray(shadowChildren));
    allChildren.forEach(function (child) {
      return traverseForMediaStateReceivers(child, mediaStateReceiverCallback2);
    });
  };

  var name = rootNode == null ? void 0 : rootNode.nodeName.toLowerCase();

  if (name.includes("-") && !isMediaStateReceiver(rootNode)) {
    globalThis.customElements.whenDefined(name).then(function () {
      traverseForMediaStateReceiversSync(rootNode, mediaStateReceiverCallback);
    });
    return;
  }

  traverseForMediaStateReceiversSync(rootNode, mediaStateReceiverCallback);
};

var _propagateMediaState = function _propagateMediaState(els, stateName, val) {
  els.forEach(function (el) {
    if (stateName in el) {
      el[stateName] = val;
      return;
    }

    var relevantAttrs = getMediaUIAttributesFrom(el);
    var attrName = stateName.toLowerCase();
    if (!relevantAttrs.includes(attrName)) return;
    setAttr(el, attrName, val);
  });
};

var getStateValue = function getStateValue(els, stateName) {
  var _iterator = _createForOfIteratorHelper(els),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var el = _step.value;

      if (stateName in el) {
        return el[stateName];
      }

      var relevantAttrs = getMediaUIAttributesFrom(el);
      var attrName = stateName.toLowerCase();
      if (!relevantAttrs.includes(attrName)) continue;
      return el.getAttribute(attrName);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var monitorForMediaStateReceivers = function monitorForMediaStateReceivers(rootNode, registerMediaStateReceiver, unregisterMediaStateReceiver) {
  traverseForMediaStateReceivers(rootNode, registerMediaStateReceiver);

  var registerMediaStateReceiverHandler = function registerMediaStateReceiverHandler(evt) {
    var _a;

    var el = (_a = evt == null ? void 0 : evt.composedPath()[0]) != null ? _a : evt.target;
    registerMediaStateReceiver(el);
  };

  var unregisterMediaStateReceiverHandler = function unregisterMediaStateReceiverHandler(evt) {
    var _a;

    var el = (_a = evt == null ? void 0 : evt.composedPath()[0]) != null ? _a : evt.target;
    unregisterMediaStateReceiver(el);
  };

  rootNode.addEventListener(MediaUIEvents.REGISTER_MEDIA_STATE_RECEIVER, registerMediaStateReceiverHandler);
  rootNode.addEventListener(MediaUIEvents.UNREGISTER_MEDIA_STATE_RECEIVER, unregisterMediaStateReceiverHandler);

  var mutationCallback = function mutationCallback(mutationsList) {
    mutationsList.forEach(function (mutationRecord) {
      var _mutationRecord$added = mutationRecord.addedNodes,
          addedNodes = _mutationRecord$added === void 0 ? [] : _mutationRecord$added,
          _mutationRecord$remov = mutationRecord.removedNodes,
          removedNodes = _mutationRecord$remov === void 0 ? [] : _mutationRecord$remov,
          type = mutationRecord.type,
          target = mutationRecord.target,
          attributeName = mutationRecord.attributeName;

      if (type === "childList") {
        Array.prototype.forEach.call(addedNodes, function (node) {
          return traverseForMediaStateReceivers(node, registerMediaStateReceiver);
        });
        Array.prototype.forEach.call(removedNodes, function (node) {
          return traverseForMediaStateReceivers(node, unregisterMediaStateReceiver);
        });
      } else if (type === "attributes" && attributeName === MediaStateReceiverAttributes.MEDIA_CHROME_ATTRIBUTES) {
        if (isMediaStateReceiver(target)) {
          registerMediaStateReceiver(target);
        } else {
          unregisterMediaStateReceiver(target);
        }
      }
    });
  };

  var prevSlotted = [];

  var slotChangeHandler = function slotChangeHandler(event) {
    var slotEl = event.target;
    if (slotEl.name === "media") return;
    prevSlotted.forEach(function (node) {
      return traverseForMediaStateReceivers(node, unregisterMediaStateReceiver);
    });
    prevSlotted = _toConsumableArray(slotEl.assignedElements({
      flatten: true
    }));
    prevSlotted.forEach(function (node) {
      return traverseForMediaStateReceivers(node, registerMediaStateReceiver);
    });
  };

  rootNode.addEventListener("slotchange", slotChangeHandler);
  var observer = new MutationObserver(mutationCallback);
  observer.observe(rootNode, {
    childList: true,
    attributes: true,
    subtree: true
  });

  var unsubscribe = function unsubscribe() {
    traverseForMediaStateReceivers(rootNode, unregisterMediaStateReceiver);
    rootNode.removeEventListener("slotchange", slotChangeHandler);
    observer.disconnect();
    rootNode.removeEventListener(MediaUIEvents.REGISTER_MEDIA_STATE_RECEIVER, registerMediaStateReceiverHandler);
    rootNode.removeEventListener(MediaUIEvents.UNREGISTER_MEDIA_STATE_RECEIVER, unregisterMediaStateReceiverHandler);
  };

  return unsubscribe;
};

if (!globalThis.customElements.get("media-controller")) {
  globalThis.customElements.define("media-controller", MediaController);
}

var media_controller_default = MediaController;
export { Attributes, media_controller_default as default };